
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/medical-card/louisiana",
      function () {
        return require("private-next-pages/medical-card/louisiana.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/medical-card/louisiana"])
      });
    }
  